import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const BoxesFilledIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  (props, ref) => (
    <Icon data-testid="boxesFilled" ref={ref} {...props}>
      <path d="M17.87,11.8a1.59,1.59,0,0,0-.94,0l.39-.18a.11.11,0,0,1,.15,0Zm2,.95a17.35,17.35,0,0,0-2-.95Zm1.1.53-.41-.2-.69-.33-2-.95a1.59,1.59,0,0,0-.94,0l-2,1-.69.33-.41.2,3.59,1.58Zm-6.07-.53-.69.33Zm2-1a18.72,18.72,0,0,0-2,1Zm3.64,1.29-.69-.33ZM6.62,14.86l3.58-1.59L6.7,11.61l-.08,0L3,13.28Zm11.53,1.31v5L22,19.47v-5Zm-5.39-1.72v5l3.89,1.72v-5Zm0-7.37v5l3.89-1.84V5.36ZM12,2.49,8.42,4.19,12,5.78l3.58-1.59ZM7.37,16.17v5l3.89-1.72v-5Zm0-10.81v4.91l3.89,1.84v-5ZM2,14.45v5l3.89,1.72v-5Z" />
    </Icon>
  ),
) as IconWithRender;

BoxesFilledIcon.displayName = 'BoxesFilledIcon';
BoxesFilledIcon.renderIcon = (props) => <BoxesFilledIcon {...props} />;
export default BoxesFilledIcon;
